import { getSecureLocalItem } from "utils/secureSessionStorage";
import api from "./api";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const getAllVendors = async () => {
  const config = await getAuthConfig();
  const response = await api.get("/getAllVendors", config);
  return response;
};

export const createVendor = async (vendorData) => {
  const config = await getAuthConfig();
  const response = await api.post("/registerVendor", vendorData, config);
  return response;
};

export const updateVendor = async (vendorId, updateData) => {
  const config = await getAuthConfig();
  const response = await api.put(
    `/updateVendor/${vendorId}`,
    updateData,
    config
  );
  return response;
};

export const updateVendorApproval = async (vendorId, isApproved) => {
  const config = await getAuthConfig();
  const response = await api.put(
    `/updateVendorApproval/${vendorId}`,
    { isApproved },
    config
  );
  return response;
};
